import AudioFile from './audio-file';
class Beat extends AudioFile {
    constructor(beatInfo) {
        super(beatInfo.url);
        this.info = beatInfo;
    }
    async init() {
        await super.init();
        this.info.setDuration(this.duration);
    }
}
export default Beat;
export { Beat, };
